export default __webpack_public_path__ + "static/media/pluralistische-communicatie.b7844d78.svg";